"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _getFormMethods2 = _interopRequireDefault(require("../Form/getFormMethods"));

var _RadioButton = require("./RadioButton.styles");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var RadioButton = function RadioButton(_ref) {
  var checked = _ref.checked,
      className = _ref.className,
      disabled = _ref.disabled,
      error = _ref.error,
      id = _ref.id,
      name = _ref.name,
      label = _ref.label,
      onChange = _ref.onChange,
      validations = _ref.validations,
      value = _ref.value;

  var _getFormMethods = (0, _getFormMethods2["default"])(),
      errors = _getFormMethods.errors,
      register = _getFormMethods.register;

  var fieldErrors = error || errors[id];

  var _useState = (0, _react.useState)(checked),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var handleRadioButtonChange = (0, _react.useCallback)(function (event) {
    setState(event.target.checked);

    if (onChange) {
      onChange(event);
    }
  }, [onChange]);
  return /*#__PURE__*/_react["default"].createElement(_RadioButton.StyledRadioButton, {
    key: "".concat(id, "-").concat(state),
    disabled: disabled,
    className: className
  }, /*#__PURE__*/_react["default"].createElement("input", {
    checked: state,
    disabled: disabled,
    id: id,
    name: name,
    onChange: handleRadioButtonChange,
    ref: register(validations),
    type: "radio",
    value: state ? value : ''
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "checkmark"
  }), /*#__PURE__*/_react["default"].createElement(_RadioButton.StyledRadioButtonLabel, {
    htmlFor: id
  }, label), fieldErrors && /*#__PURE__*/_react["default"].createElement(_RadioButton.StyledRadioButtonError, null, fieldErrors.message));
};

RadioButton.defaultProps = {
  checked: false,
  className: null,
  disabled: false,
  error: undefined,
  onChange: null,
  validations: null,
  value: ''
};
RadioButton.propTypes = {
  /** Checked state */
  checked: _propTypes.bool,

  /** Custom class to be added to the container */
  className: _propTypes.string,

  /** Disabled state */
  disabled: _propTypes.bool,

  /** For passing external errors to the component */
  error: (0, _propTypes.shape)({
    message: _propTypes.string
  }),

  /** RadioButton unique identifier */
  id: _propTypes.string.isRequired,

  /** The button label */
  label: _propTypes.string.isRequired,

  /** RadioButton group identifier */
  name: _propTypes.string.isRequired,

  /** Function to trigger when RadioButton state is updated */
  onChange: _propTypes.func,

  /** Validations to be provided for the component. */
  validations: (0, _propTypes.shape)({
    required: (0, _propTypes.oneOfType)([_propTypes.bool, _propTypes.string]),
    validate: (0, _propTypes.shape)({})
  }),

  /** RadioButton return value */
  value: _propTypes.string
};
RadioButton.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "RadioButton",
  "props": {
    "checked": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Checked state",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Custom class to be added to the container",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Disabled state",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "error": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "For passing external errors to the component",
      "type": {
        "name": "shape",
        "value": {
          "message": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false
    },
    "onChange": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Function to trigger when RadioButton state is updated",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "validations": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Validations to be provided for the component.",
      "type": {
        "name": "shape",
        "value": {
          "required": {
            "name": "union",
            "value": [{
              "name": "bool"
            }, {
              "name": "string"
            }],
            "required": false
          },
          "validate": {
            "name": "shape",
            "value": {},
            "required": false
          }
        }
      },
      "required": false
    },
    "value": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "RadioButton return value",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "id": {
      "description": "RadioButton unique identifier",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "label": {
      "description": "The button label",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "name": {
      "description": "RadioButton group identifier",
      "type": {
        "name": "string"
      },
      "required": true
    }
  }
};
var _default = RadioButton;
exports["default"] = _default;